import CreateEggDocument from './CreateEggDocument'

export default CreateEggDocument
